export default __webpack_public_path__ + "static/media/large.a17adfc5.jpg";